var map = {
	"./0_Default.svg": 1327,
	"./Bright_1.svg": 6079,
	"./Clear_1.svg": 8233,
	"./Clear_3.svg": 6228,
	"./Clear_5.svg": 5626,
	"./Cloudy.svg": 6151,
	"./Day.svg": 1807,
	"./Evening_1.svg": 7881,
	"./Foggy_1.svg": 9781,
	"./Foggy_2.svg": 3142,
	"./Haze_2.svg": 7906,
	"./Hot_1.svg": 7240,
	"./Hot_2.svg": 9131,
	"./Snow_1.svg": 4486,
	"./Snow_2.svg": 3621,
	"./Windy.svg": 6350,
	"assets/img/avatars/0_Default.svg": 1327,
	"assets/img/avatars/Bright_1.svg": 6079,
	"assets/img/avatars/Clear_1.svg": 8233,
	"assets/img/avatars/Clear_3.svg": 6228,
	"assets/img/avatars/Clear_5.svg": 5626,
	"assets/img/avatars/Cloudy.svg": 6151,
	"assets/img/avatars/Day.svg": 1807,
	"assets/img/avatars/Evening_1.svg": 7881,
	"assets/img/avatars/Foggy_1.svg": 9781,
	"assets/img/avatars/Foggy_2.svg": 3142,
	"assets/img/avatars/Haze_2.svg": 7906,
	"assets/img/avatars/Hot_1.svg": 7240,
	"assets/img/avatars/Hot_2.svg": 9131,
	"assets/img/avatars/Snow_1.svg": 4486,
	"assets/img/avatars/Snow_2.svg": 3621,
	"assets/img/avatars/Windy.svg": 6350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9443;